import { t, Lang } from './i18n'
import { useLang } from '../i18n/LangProvider'
import styles from './ReadOnlyBanner.module.css'

export function ReadOnlyBanner({ lang: langProp }: { lang?: Lang }) {
  const ctxLang = useLang()
  const lang = langProp ?? ctxLang
  return (
    <div role="status" className={styles.banner}>
      <span aria-hidden>🔒</span>
      <strong>{t('temporadaCerradaBanner', lang)}</strong>
    </div>
  )
}
